import { EOrderType } from '@aqx-core/common/api/order';

export const DEFAULT_ORDER_TYPE_FILTER_OPTIONS = [
  EOrderType.BUY,
  EOrderType.SELL,
  EOrderType.BUY_STOP,
  EOrderType.SELL_STOP,
  EOrderType.BUY_LIMIT,
  EOrderType.SELL_LIMIT
];
